module.exports = __webpack_public_path__ + "static/media/product_memory_lcd.2835ad2a.png";